import { Inject, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { FiliaisResponse } from '../models/filiais.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FiliaisApiService extends UtilsBaseApiService<FiliaisApiService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('filiais', injector, environment.BASE_API_URL);
  }

  getFiliais(idVendedor:number): Observable<FiliaisResponse[]>{
    const param = {['idVendedor']: idVendedor}
    return this.getAll<FiliaisResponse>(param).pipe(
      map((data: FiliaisResponse[]) => {
        data = data.map((filial: FiliaisResponse) => {
          filial.razaoSocial = filial.razaoSocial
            .split('-')
            .reverse()
            .join(' - ');

          return filial;
        });
        return data;
      })
    );
  }
}
